var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "49px",
    viewBox: "0 0 48 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multiple-Selection-Drawer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.26524257
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Favorites",
    transform: "translate(-464.000000, -301.000000)",
    fill: "#49C5B1",
    stroke: "#49C5B1",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(286.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Actions/Favorite-Active",
    transform: "translate(181.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2,8.8817842e-16 C31.7939722,8.8817842e-16 34.9980011,1.45077792 37.3067561,3.80986008 C39.5849182,6.13768233 41,9.36442366 41,12.9918256 C41,19.9491508 35.5882463,25.9252129 26.0966185,34.7385655 L26.0966185,34.7385655 L20.9898662,39.453554 L15.9613628,34.7760736 C6.42845237,25.9432384 1,19.9596032 1,12.9918256 C1,9.36442366 2.41508182,6.13768233 4.69324386,3.80986008 C7.00199894,1.45077792 10.2060278,8.8817842e-16 13.8,0 C16.3693637,0 18.8764142,0.78478337 21.0004998,2.14878453 C23.1240582,0.784635486 25.6308784,0 28.2,0 Z",
    id: "Color"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c601de70b0738145743cffde29f0bd73.svg";
export { ForwardRef as ReactComponent };